import type { CSSProperties, PropsWithChildren } from "react";
import { Component as ReactComponent } from "react";

import type { ClassValue } from "clsx";
import clsx from "clsx";
import { shallowEqual } from "shallow-equal";

export interface IComponent extends IDefaultAttributes, PropsWithChildren {
    key?: number | string;
}

export interface IDefaultAttributes {
    id?: string;
    className?: string;
    style?: CSSProperties;
    clientId?: string;
}

export const defaultAttributes = (props: IDefaultAttributes, ...className: ClassValue[]) => ({
    className: clsx(className, props.className),
    id: props.clientId,
    style: props.style,
});

export abstract class Component<TProps extends IComponent = {}, TState = {}> extends ReactComponent<
    TProps,
    TState
> {
    public static defaultProps: IComponent = {};

    protected isPureComponent: boolean = false;

    public shouldComponentUpdate(nextProps: TProps, nextState: TState): boolean {
        if (!this.isPureComponent) {
            return true;
        }

        if (this.props.children) {
            return true;
        }

        return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
    }

    protected rootDefaultAttributes(...className: string[]): IDefaultAttributes {
        return defaultAttributes(this.props, ...className);
    }
}
